export const SECOND_MS = 1000
export const MINUTE_MS = SECOND_MS * 60
export const HOUR_MS = MINUTE_MS * 60
export const DAY_MS = HOUR_MS * 24
export const WEEK_MS = DAY_MS * 7
export const MONTH_MS = DAY_MS * 31
export const YEAR_MS = DAY_MS * 365

export const APP_NAME = 'towns'
